import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { v4 as uuid } from 'uuid';

import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../../components/common/WhitePad/WhitePad';
import PurchaseSecondaryNavigation from '../../../../../components/common/navigation/PurchaseSecondaryNavigation';
import TitleComponent from '../../../../../components/common/forms/Title/TitleComponent';

import InventoryApi from '../../../../../services/api/InventoryApi';

import ReserveProductBlock from './components/ReserveProductBlock';
import { ProductX } from '~/src/types/Misc';

interface ParamProps {
  id: string;
}

export default function PurchaseOrderReserve(): JSX.Element {
  const { id } = useParams<ParamProps>();
  const [itemData, setItemData] = useState<ProductX[] | null>(null);
  const getItem = async (): Promise<void> => {
    const res = await InventoryApi.getAvailableForReservation(id);
    if (res.status === StatusCodes.OK) {
      setItemData(res.data);
    }
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <WhitePad isFluid>
      <PurchaseSecondaryNavigation />
      <TitleComponent title="Reserve Units" />
      {itemData?.map((item) => {
        return <ReserveProductBlock item={item} key={uuid()} id={id} />;
      })}
    </WhitePad>
  );
}
